export const API_ROOT = 'https://webcamwidget.fullmarketing.at/api/';
export const MODIMAGEPATH = 'https://tn-wetterwidget.fullmarketing.at/img/';
export const METGIS_KEY = 'TFVLVPteKe57d5MPVDwaSfRxZ2fMImOg9AuTfcGPNJ7Tj3nw1';
export const METGIS_API_URL = 'https://api.metgis.com/forecast';